<template>
  <div class="date-btn main-color fw-semibold position-relative">
    <i class="flaticon-calendar"></i>
    {{ formattedDate }}
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "CurrentDate",
  setup() {
    const formattedDate = ref("");

    onMounted(() => {
      const months = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];

      const currentDate = new Date();

      formattedDate.value = `${currentDate.getDate()} de ${
        months[currentDate.getMonth()]
      } de ${currentDate.getFullYear()}`;
    });

    return {
      formattedDate,
    };
  },
});
</script>
